var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-textarea',{class:_vm.inputClass,attrs:{"id":"textarea-no-resize","rows":_vm.minRow,"max-rows":_vm.maxRow,"readonly":""},model:{value:(_vm.itemData),callback:function ($$v) {_vm.itemData=$$v},expression:"itemData"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }